import request from '../utils/http.js'
const qs = require('qs')
export const getList = () => request({
  url: '/api.php/main/index',
  method: 'POST'
})
// 获取分类列表
export const getClassificationList = () => request({
  url: '/api.php/shop/get_shop_type',
  method: 'POST'
})
// 获取商品列表
export const getCommodityList = (data) => request({
  url: '/api.php/shop/get_list',
  method: 'POST',
  data: qs.stringify(data)
})
export const getUserAgreement = () => request({
  url: '/api/index.php/main/news_show/id/1',
  method: 'Get'
})
// 账号注册
export const getUserRegistered = (data) => request({
  url: '/api.php/user/reg',
  method: 'POST',
  data: qs.stringify(data)
})
// 发送短信验证码
export const getRegisterCode = (data) => request({
  url: '/api.php/api/sendsms',
  method: 'POST',
  data: qs.stringify(data)
})
// 账号密码登录
export const getLogin = (data) => request({
  url: '/api.php/user/login',
  method: 'POST',
  data: qs.stringify(data)
})
// 找回密码
export const getForgot = (data) => request({
  url: '/api.php/user/findpass',
  method: 'POST',
  data: qs.stringify(data)
})
// 详情列表
export const getCommodityDetailList = (data) => request({
  url: '/api.php/shop/get_shop_info',
  method: 'POST',
  data: qs.stringify(data)
})
// 商品下单
export const getOrderOklList = (data) => request({
  url: '/api.php/order/orderok',
  method: 'POST',
  data: qs.stringify(data)
})
// 收藏状态
export const setCollectionState = (data) => request({
  url: '/api.php/collection/set_state',
  method: 'POST',
  data: qs.stringify(data)
})
// 我的收藏
export const myCollection = (data) => request({
  url: '/api.php/collection/getcollectionlist',
  method: 'POST',
  data: qs.stringify(data)
})
// 文章分类
export const getnewstype = () => request({
  url: '/api.php/news/getnewstype',
  method: 'POST'
})
// 文章列表
export const getnewslist = (data) => request({
  url: '/api.php/news/getnewslist',
  method: 'POST',
  data: qs.stringify(data)
})
// 订单
export const getOrderList = (data) => request({
  url: '/api.php/order/getorderlist',
  method: 'POST',
  data: qs.stringify(data)
})
// 取消订单
export const getOrderCancel = (data) => request({
  url: '/api.php/order/ordercancel',
  method: 'POST',
  data: qs.stringify(data)
})
// 确认订单
export const getMakeSureOrder = (data) => request({
  url: '/api.php/order/orderok',
  method: 'POST',
  data: qs.stringify(data)
})
// 个人信息
export const getUserInfo = () => request({
  url: '/api.php/user/getuserinfo',
  method: 'POST'
})
// 积分详情
export const getIntegralDetailsList = (data) => request({
  url: '/api.php/pay/moneylog',
  method: 'POST',
  data: qs.stringify(data)
})
// 积分奖励
export const getAwardList = () => request({
  url: '/api.php/pay/withdrawal',
  method: 'POST'
})
// 数据统计
export const getstatistics = () => request({
  url: '/api.php/user/getstatistics',
  method: 'POST'
})
// 我的好友
export const getMyfriends = (data) => request({
  url: '/api.php/user/getagentlist',
  method: 'POST',
  data: qs.stringify(data)

})
// 我的团队
export const getmygroup = (data) => request({
  url: '/api.php/user/getmygroup',
  method: 'POST',
  data: qs.stringify(data)

})

// 新增编辑地址
export const addressFn = (data) => request({
  url: '/api.php/address/editaddress',
  method: 'POST',
  data: qs.stringify(data)
})
// 收货地址列表
export const addressList = (data) => request({
  url: '/api.php/address/getaddress',
  method: 'POST',
  data: qs.stringify(data)
})
// 修改默认地址
export const addressDefault = (data) => request({
  url: '/api.php/address/setdefault',
  method: 'POST',
  data: qs.stringify(data)
})
// 删除地址
export const removeAddress = (data) => request({
  url: '/api.php/address/deladdress',
  method: 'POST',
  data: qs.stringify(data)
})
// 邀请海报
export const invitationList = () => request({
  url: '/api.php/user/getsharepic',
  method: 'POST'
})
// 积分商城
export const getWelfareList = (data) => request({
  url: '/api.php/score/getscorelist',
  method: 'POST',
  data: qs.stringify(data)
})
// 积分流水
export const getterIntegralWater = (data) => request({
  url: '/api.php/score/scorelog',
  method: 'POST',
  data: qs.stringify(data)
})
// 兑换记录
export const getForRecordList = (data) => request({
  url: '/api.php/score/getorderlist',
  method: 'POST',
  data: qs.stringify(data)
})
// 奖励提现
export const dowithdrawalInfo = (data) => request({
  url: '/api.php/pay/dowithdrawal',
  method: 'POST',
  data: qs.stringify(data)
})
// 提现记录
export const getWithdrawallogList = (data) => request({
  url: '/api.php/pay/withdrawallog',
  method: 'POST',
  data: qs.stringify(data)
})
// 获取积分商品详情
export const getRecordDetailList = (data) => request({
  url: '/api.php/score/getscoreinfo',
  method: 'POST',
  data: qs.stringify(data)
})
// 基础资料
export const modifyPersonInfo = (data) => request({
  url: '/api.php/user/edituserinfo',
  method: 'POST',
  data: qs.stringify(data)
})
// 基础手机号
export const modifyPhone = (data) => request({
  url: '/api.php/user/editphone',
  method: 'POST',
  data: qs.stringify(data)
})
// 头像上传
export const uploadAvatar = (data) => request({
  url: '/api.php/api/upload',
  method: 'POST',
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  data: data
})
// 支付订单详情
export const getOrderInfo = (data) => request({
  url: '/api.php/order/orderinfo',
  method: 'POST',
  data: qs.stringify(data)
})
// 发起支付
export const doPay = (data) => request({
  url: '/api.php/pay/dopay',
  method: 'POST',
  data: qs.stringify(data)
})
// 微信登录链接
export const toWeiLogin = (data) => request({
  url: '/api.php/user/wxLoginmp',
  method: 'POST',
  data: qs.stringify(data)
})
// 绑定微信
export const toWeiLoginBind = (data) => request({
  url: '/api.php/user/wxloginmpbind',
  method: 'POST',
  data: qs.stringify(data)
})
// 积分兑换
export const scoreBuy = (data) => request({
  url: '/api.php/score/buy',
  method: 'POST',
  data: qs.stringify(data)
})
// 微信登录绑定
export const weixinBind = (data) => request({
  url: '/api.php/user/wxloginmpbind',
  method: 'POST',
  data: qs.stringify(data)
})
// 我的库存
export const getMyInventory = (data) => request({
  url: '/api.php/warehouse/getinfo',
  method: 'POST',
  data: qs.stringify(data)
})
// 补货订单
export const getAddShopOrder = (data) => request({
  url: '/api.php/warehouse/orderok',
  method: 'POST',
  data: qs.stringify(data)
})
// 库存明细
export const getInventoryDetail = (data) => request({
  url: '/api.php/warehouse/warehouselog',
  method: 'POST',
  data: qs.stringify(data)
})
// 配货页面备注
export const getDistribution = (data) => request({
  url: '/api.php/warehouse/getdistribution',
  method: 'POST',
  data: qs.stringify(data)
})
// 提交配货申请
export const getAddDistribution = (data) => request({
  url: '/api.php/warehouse/distribution',
  method: 'POST',
  data: qs.stringify(data)
})
// 提货
export const getRaising = (data) => request({
  url: '/api.php/warehouse/raising',
  method: 'POST',
  data: qs.stringify(data)
})
